import { GRAY_SCALE_LIGHT, ACCENT_LIGHT, SEMANTIC_COLORS, SEMANTIC_BACKGROUNDS } from './tokens/colors';
import { FONT_FAMILY, FONT_FAMILY_MONO, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, ROLES } from './tokens/typography';
import { spacing } from './tokens/spacing';
import { BORDER_RADIUS, BORDER_WIDTH } from './tokens/borders';
import { BOX_SHADOW_LIGHT } from './tokens/shadows';
import { ANIMATION_DURATION, TRANSITIONS } from './tokens/animations';
import { focusShadow } from './tokens/focusShadow';

const gray = GRAY_SCALE_LIGHT;

export const lightTheme = {
  name: 'light',
  isDark: false,

  accent: {
    primary:    ACCENT_LIGHT.primary,
    secondary:  ACCENT_LIGHT.secondary,
    tertiary:   ACCENT_LIGHT.tertiary,
    quaternary: ACCENT_LIGHT.quaternary,
    accent10:   ACCENT_LIGHT.accent10,
  },

  background: {
    primary:           gray.gray1,   // canvas (#ffffff) — card body
    secondary:         gray.gray2,   // canvas-soft (#f6f9fc) — page bg
    tertiary:          gray.gray4,   // canvas-tint (#f0f4f8) — row hover
    quaternary:        gray.gray5,   // hairline (#e3e8ee) — pressed surface
    invertedPrimary:   gray.gray12,
    invertedSecondary: gray.gray11,
    danger:            '#fee2e2',    // critical-bg
    transparent: {
      primary:   'rgba(255, 255, 255, 0.7)',
      secondary: 'rgba(255, 255, 255, 0.6)',
      strong:    'rgba(203, 213, 224, 0.5)',
      medium:    'rgba(227, 232, 238, 0.5)',
      light:     'rgba(246, 249, 252, 0.5)',
    },
  },

  border: {
    color: {
      strong:  gray.gray6,    // hairline-strong (#cbd5e0)
      medium:  gray.gray5,    // hairline (#e3e8ee) — DEFAULT card border
      light:   gray.gray4,    // very subtle separator
      danger:  '#fca5a5',
      blue:    '#a8c3de',
    },
    radius: BORDER_RADIUS,
    width:  BORDER_WIDTH,
  },

  boxShadow: BOX_SHADOW_LIGHT,

  font: {
    family:     FONT_FAMILY,
    familyMono: FONT_FAMILY_MONO,
    size:       FONT_SIZE,
    weight:     FONT_WEIGHT,
    color: {
      primary:    gray.gray12,  // ink (#0d253d)
      secondary:  gray.gray11,  // ink-secondary (#273951)
      tertiary:   gray.gray9,   // ink-mute (#64748d)
      light:      gray.gray8,   // ink-mute-2 (#94a3b8)
      extraLight: gray.gray7,
      inverted:   gray.gray1,
      danger:     SEMANTIC_COLORS.red,
    },
    lineHeight: LINE_HEIGHT,
    roles:      ROLES,
  },

  color: SEMANTIC_COLORS,
  colorBg: SEMANTIC_BACKGROUNDS,

  grayScale: gray,

  spacing,

  animation: {
    duration: ANIMATION_DURATION,
    transition: TRANSITIONS,
  },

  icon: {
    size:   { sm: 14, md: 16, lg: 20, xl: 24 },
    stroke: { sm: 1.6, md: 2, lg: 2.5 },
  },

  focusShadow,
};
